import { render, staticRenderFns } from "./ReasonFailures.vue?vue&type=template&id=84f1c68e"
import script from "./ReasonFailures.vue?vue&type=script&lang=ts"
export * from "./ReasonFailures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports